<template>
  <div class="split-container">
    <div
      class="split-container-child left-container"
      v-if="showLeftContainer"
      v-bind:class="{
        rightContentShow: showRightContainer == true,
      }"
    >
      <slot name="leftContent"></slot>
    </div>
    <div
      class="split-container-child right-container"
      v-if="showRightContainer"
    >
      <slot name="rightContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLeftContainer: {
      type: Boolean,
      default: true,
    },
    showRightContainer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.split-container {
  display: flex;
  .left-container {
    min-width: 50%;
  }
}
.screen-small,
.screen-medium,
.screen-large {
  .split-container-child {
    flex: 1 1 0px;
  }
}

.screen-x-small {
  .split-container-child {
    flex: auto;
  }
}

.split-container-child.right-container {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 0;
  margin-right: 0;
}

.split-container-child.right-container .split-view-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: none;
  box-shadow: none;
}

.split-container-child.right-container .view-card {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
